import { FILTER_TYPES } from 'components/FilterPod';

const filters = () => [
  {
    title: 'شناسه سرویس',
    label: 'شناسه سرویس',
    keyName: 'id',
    key: 'id',
    id: '1111', // fake id
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
  {
    title: 'نام سرویس',
    label: 'نام سرویس',
    keyName: 'text',
    id: '2222', // fake id
    key: 'text',
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'وضعیت سرویس',
    label: 'وضعیت سرویس',
    keyName: 'showEnable',
    key: 'showEnable',
    id: '3333', // fake id
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'true',
          label: 'فعال',
        },
        {
          value: 'false',
          label: 'غیر فعال',
        },
      ],
    },
  },
];

export default filters;
